// hooks/maintenance/useDetailDocs.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchDetailDocs, uploadDetailDoc, updateDetailDoc, deleteDetailDoc } from '../../api/maintenance/maintenanceDetailsService';

export const useMaintenanceDetailDocs = (manId, detailId) => {
  const qc = useQueryClient();
  const key = ['detailDocs', manId, detailId];

  const { data = [], isLoading, error } = useQuery({
    queryKey: key,
    queryFn: () => fetchDetailDocs({ manId, detailId }),
    enabled: !!manId && !!detailId,
    staleTime: 60_000,
  });

  const upload = useMutation({
    mutationFn: (payload) => uploadDetailDoc({ manId, detailId, payload }),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });

  const update = useMutation({
    mutationFn: ({ docId, formData }) => updateDetailDoc({ manId, detailId, docId, formData }),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });

  const remove = useMutation({
    mutationFn: (docId) => deleteDetailDoc({ manId, detailId, docId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });

  return { docs: data, isLoading, error, upload, update, remove };
};
